import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { branch, lifecycle, renderComponent } from 'recompose';
import { Loader } from 'semantic-ui-react';
import { selectReady } from './search.selectors';
import { EMPLOYEE_SEARCH_LIFECYCLE } from './search.types';

export const withDispatchers = connect(null, {
  visit: EMPLOYEE_SEARCH_LIFECYCLE.visit,
  exit: EMPLOYEE_SEARCH_LIFECYCLE.exit,
});

export const withLifecycleActions = lifecycle({
  componentDidMount() {
    this.props.visit(this.props);
  },
  componentWillUnmount() {
    this.props.exit(this.props);
  },
});

const withReadyState = connect(state => ({ ready: selectReady(state) }));

const withLoadingSpinner = branch(
  props => !props.ready,
  renderComponent(() => <Loader active inline="centered" />),
);

export const withInitializer = compose(
  withDispatchers,
  withLifecycleActions,
  withReadyState,
  withLoadingSpinner,
);
